import type { ReactNode } from "react"

type IconName = "account" | "back" | "balance" | "history" | "home" | "notice" | "search" | "shop" | "status"

const paths: Readonly<Record<IconName, ReactNode>> = {
  account: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M5 21a7 7 0 0 1 14 0" />
    </>
  ),
  back: <path d="m15 5-7 7 7 7" />,
  balance: (
    <>
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M16 11h5v4h-5a2 2 0 0 1 0-4Z" />
    </>
  ),
  history: (
    <>
      <path d="M12 7v5l3 2" />
      <path d="M5 5a9 9 0 1 1-2 9" />
    </>
  ),
  home: <path d="m4 11 8-7 8 7v9h-5v-6H9v6H4v-9Z" />,
  notice: (
    <>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
      <path d="M10 21h4" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="m16 16 4 4" />
    </>
  ),
  shop: (
    <>
      <path d="M4 8h16v12H4z" />
      <path d="M8 8V5h8v3" />
    </>
  ),
  status: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6l4 2" />
    </>
  ),
}

export const Icon = ({ name }: { readonly name: IconName }) => (
  <svg aria-hidden="true" className="icon" fill="none" viewBox="0 0 24 24">
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
      {paths[name]}
    </g>
  </svg>
)
